const en: Record<string, string> = {
  'features.guitarMetronome.title': 'Metronome',
  'features.guitarMetronome.start': 'Start',
  'features.guitarMetronome.stop': 'Stop',
  'features.guitarMetronome.tap': 'Tap',
  'features.guitarMetronome.beatsPerBar': 'Beats per bar',
  'features.guitarMetronome.accentOn': 'Accent beat 1',
  'features.guitarMetronome.accentOff': 'No accent',
};

export default en;
